import { useMemo } from 'react';
import Link from 'next/link';
import { IMenuItem } from '~/src/api/content/menu';
import * as ST from '~/src/components/Header/styled';

interface IProps {
    menuItems: IMenuItem[],
    isTablet: boolean;
    onClick: (item: string, menuType?: string) => void;
    onHover: (item: string, menuType?: string) => void;
}

const TABLET_TOP_MENU_COUNT = 2;
const TOPMENU_ITEMS_COUNT = 3;

const TopMenu = ({ menuItems, isTablet, onClick, onHover }: IProps): JSX.Element => {
    const preparedTopMenu = useMemo(() => {
        const TopMenuItems = isTablet ? TABLET_TOP_MENU_COUNT : TOPMENU_ITEMS_COUNT;
        if (menuItems.length <= TopMenuItems) {
            return { visible: menuItems };
        }

        const visible = menuItems.slice(0, TopMenuItems);
        const collapsed = menuItems.slice(TopMenuItems);

        return { visible, collapsed };
    }, [isTablet, menuItems]);

    return (
        <>
            {
                preparedTopMenu?.visible.map(item => (
                    <ST.TopMenuItem key={item.id} data-test='top-menu-item'>
                        <Link href={item.link} prefetch={false}>
                            <a
                                onClick={() => onClick(item.title, 'Left menu')}
                                onMouseEnter={() => onHover(item.title, 'Left menu')}
                            >
                                {item.title}
                            </a>
                        </Link>
                    </ST.TopMenuItem>
                ))
            }
            {
                preparedTopMenu?.collapsed && preparedTopMenu.collapsed.length > 0 && (
                    <ST.CollapsedTopMenuItem>
                        Другие сайты
                        <ST.CollapsedMenu data-test='top-menu-collapsed'>
                            {preparedTopMenu.collapsed.map(item => (
                                <Link
                                    key={item.id}
                                    href={item.link}
                                    prefetch={false}
                                >
                                    <a
                                        onClick={() => onClick(item.title, 'Left menu')}
                                        onMouseEnter={() => onHover(item.title, 'Left menu')}
                                    >
                                        {item.title}
                                    </a>
                                </Link>
                            ))}
                        </ST.CollapsedMenu>
                    </ST.CollapsedTopMenuItem>
                )
            }
        </>
    );
};

export default TopMenu;
